/**
 * Theme Redux Actions
 * Actions for managing theme mode (light/dark)
 */

export const TOGGLE_THEME = 'TOGGLE_THEME';
export const SET_THEME = 'SET_THEME';

/**
 * Toggle between light and dark mode
 */
export const toggleTheme = () => (dispatch, getState) => {
  const currentMode = getState().theme?.mode || 'light';
  const newMode = currentMode === 'light' ? 'dark' : 'light';
  localStorage.setItem('theme-mode', newMode);
  dispatch({
    type: TOGGLE_THEME,
    payload: newMode,
  });
};

/**
 * Set theme to specific mode
 * @param {string} mode - 'light' or 'dark'
 */
export const setTheme = (mode) => {
  localStorage.setItem('theme-mode', mode);
  return {
    type: SET_THEME,
    payload: mode,
  };
};
